import Typography from "@mui/material/Typography"
import Card from "@mui/material/Card"
import Stack from "@mui/material/Stack"
import Chip from "@mui/material/Chip"
import Box from "@mui/material/Box"

import { SignalItem } from "../../interface/SignalItem"
import { SignalSource } from "./SignalSource"
import { useEffect, useState } from "react"
import { UserApi } from "../../api/UserApi"
import { Skeleton } from "@mui/material"
import { alpha, useTheme } from "@mui/material/styles"

export const SignalSourceSection = () =>
{
  const theme = useTheme()
  const [ loading, setLoading ] = useState(false)
  const [ signals, setSignals ] = useState<SignalItem[] | undefined>([])

  useEffect(() => {
    getSignals()
  }, [])

  const getSignals = async () =>
  {
    try
    {
      setLoading(true)
      const userApi = new UserApi()
      const signals = await userApi.getSignalsList()
      setSignals(signals?.sort((a, b) => b.timeout - a.timeout))
      setLoading(false)
    }
    catch(error)
    {
      setLoading(false)
    }

  }

  const getUniqueSignalSources = (signalItems: SignalItem[]) =>
  {
    const uniquieSignals: SignalItem[] = []

    for(const signal of signalItems)
    {
      if(!uniquieSignals.find(s => s.source === signal.source)) uniquieSignals.push(signal)
    }

    return uniquieSignals
  }
  
  const uniqueSignals = !loading && signals ? getUniqueSignalSources(signals) : []

  return( 
    <Box sx={{ mt: 1.25 }}>
      <Stack direction={{ xs: "column", md: "row" }} spacing={0.75} justifyContent="space-between" alignItems={{ xs: "flex-start", md: "center" }} sx={{ mb: 0.75 }}>
        <Box>
          <Typography color="textSecondary" variant="subtitle1">Signal Sources</Typography>
          <Typography variant="body2" sx={styles.subText(theme)}>
            Choose which providers are allowed to allocate capital when signal trading is enabled.
          </Typography>
        </Box>
        {!loading && (
          <Chip label={`${uniqueSignals.length} sources`} sx={styles.countChip(theme)} />
        )}
      </Stack>

      <Card sx={styles.switchesCard(theme)}>
        <>
        { !loading && signals ? uniqueSignals.map((signal, key) => <SignalSource key={key} signal={signal} />) : 
        
        <>
          <Skeleton height={56} />
          <Skeleton height={56} />
          <Skeleton height={56} />
        </> }
        </>
      </Card>
    </Box>
  )
}

const styles = {
  switchesCard: (theme: any) => ({
    padding: 0.75,
    borderRadius: "12px",
    backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.03 : 0.58),
    border: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.06 : 0.4)}`,
    boxShadow: "none",
  }),
  subText: (theme: any) => ({
    marginTop: 4,
    color: alpha(theme.palette.text.primary, 0.66),
  }),
  countChip: (theme: any) => ({
    borderRadius: "10px",
    backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.06 : 0.7),
    border: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.08 : 0.45)}`,
    '& .MuiChip-label': {
      fontWeight: 700,
    },
  }),
}
